import { render } from "./RiskDetail.vue?vue&type=template&id=2ae3631c&scoped=true"
import script from "./RiskDetail.vue?vue&type=script&lang=js"
export * from "./RiskDetail.vue?vue&type=script&lang=js"

import "./RiskDetail.vue?vue&type=style&index=0&id=2ae3631c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae3631c"]])

export default __exports__